var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.627 9.00195H30.752V7.75195C30.752 5.68422 29.0697 4.00195 27.002 4.00195H22.002C19.9342 4.00195 18.252 5.68422 18.252 7.75195V9.00195H11.377C9.65383 9.00195 8.25195 10.4038 8.25195 12.127V16.502C8.25195 17.1923 8.81164 17.752 9.50195 17.752H10.1851L11.265 40.4303C11.3604 42.4331 13.0057 44.002 15.0107 44.002H33.9932C35.9983 44.002 37.6436 42.4331 37.7389 40.4303L38.8188 17.752H39.502C40.1923 17.752 40.752 17.1923 40.752 16.502V12.127C40.752 10.4038 39.3501 9.00195 37.627 9.00195ZM20.752 7.75195C20.752 7.06273 21.3127 6.50195 22.002 6.50195H27.002C27.6912 6.50195 28.252 7.06273 28.252 7.75195V9.00195H20.752V7.75195ZM10.752 12.127C10.752 11.7823 11.0323 11.502 11.377 11.502H37.627C37.9716 11.502 38.252 11.7823 38.252 12.127V15.252C37.8667 15.252 12.3483 15.252 10.752 15.252V12.127ZM35.2417 40.3114C35.2099 40.979 34.6615 41.502 33.9932 41.502H15.0107C14.3423 41.502 13.7939 40.979 13.7622 40.3114L12.6879 17.752H36.316L35.2417 40.3114Z",
    fill: "#39695B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.502 39.002C25.1923 39.002 25.752 38.4423 25.752 37.752V21.502C25.752 20.8116 25.1923 20.252 24.502 20.252C23.8116 20.252 23.252 20.8116 23.252 21.502V37.752C23.252 38.4423 23.8116 39.002 24.502 39.002Z",
    fill: "#39695B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.752 39.002C31.4423 39.002 32.002 38.4423 32.002 37.752V21.502C32.002 20.8116 31.4423 20.252 30.752 20.252C30.0616 20.252 29.502 20.8116 29.502 21.502V37.752C29.502 38.4423 30.0616 39.002 30.752 39.002Z",
    fill: "#39695B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.252 39.002C18.9423 39.002 19.502 38.4423 19.502 37.752V21.502C19.502 20.8116 18.9423 20.252 18.252 20.252C17.5616 20.252 17.002 20.8116 17.002 21.502V37.752C17.002 38.4423 17.5616 39.002 18.252 39.002Z",
    fill: "#39695B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.d7d45c67dbb91b2495303466c80ee246.svg";
export { ForwardRef as ReactComponent };